export default __webpack_public_path__ + "static/media/welding-and-fabrication_1.b27b6c9c.png";